"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.screens = function (...sizes) {
    const { sm, md, lg } = breakpoints.values;
    const mediaQueries = {
        small: `(max-width: ${sm}px)`,
        medium: `(min-width: ${sm}px) and (max-width: ${md}px)`,
        large: `(min-width: ${md}px) and (max-width: ${lg}px)`,
        'extra-large': `(min-width: ${lg}px)`
    };
    return `@media ${sizes.map(size => mediaQueries[size]).join(', ')}`;
};
const breakpoints = {
    values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1920
    }
};
exports.breakpointsList = {
    small: breakpoints.values.sm,
    medium: breakpoints.values.md,
    large: breakpoints.values.lg,
    'extra-large': breakpoints.values.xl
};
exports.default = breakpoints;
//# sourceMappingURL=breakpoints.js.map